module.exports = __webpack_public_path__ + "img/title2.cb012cae.png";